export default __webpack_public_path__ + "static/media/overviewBannerMobile.bc2f393a.png";